import { HttpErrorCode } from '@copera/common/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SoundBoardData, SoundBoardRequests } from 'src/requests/soundboard';
import { QueryKey } from 'src/utils/react-query';

export const useAddSoundMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: addSound, isLoading: isAddingSoundLoading } =
    useMutation(SoundBoardRequests.addSound, {
      meta: {
        httpErrors: {
          [HttpErrorCode.MISSING_PARAMS]: 'error.soundboard.missing_params',
          [HttpErrorCode.LIMIT_EXCEEDED]: 'error.soundboard.file_too_large',
          [HttpErrorCode.INVALID]: 'error.soundboard.invalid_file',
          [HttpErrorCode.INVALID_CONTENT]: 'error.soundboard.invalid_file',
          [HttpErrorCode.ALREADY_EXISTS]:
            'error.soundboard.name_already_exists',
        },
      },
      onSuccess(newSound) {
        const prevSounds = queryClient.getQueryData<SoundBoardData[]>([
          QueryKey.SOUNDBOARD,
        ]);

        queryClient.setQueryData<SoundBoardData[]>(
          [QueryKey.SOUNDBOARD],
          (content) => {
            return content ? [...content, newSound] : [newSound];
          },
        );

        return { prevSounds };
      },
    });

  return {
    addSound,
    isAddingSoundLoading,
  };
};
